export class LatestRequestGate {
    constructor(max = 2) {
        this._max = max
        this._inflight = []
    }

    async run(fn) {
        const controller = new AbortController()
        while (this._inflight.length >= this._max) {
            this._inflight.shift().controller.abort()
        }

        const entry = { controller }
        this._inflight.push(entry)

        return Promise.resolve()
            .then(() => fn(controller.signal))
            .then(result => {
                if (controller.signal.aborted) return null

                const idx = this._inflight.indexOf(entry)
                if (idx > 0) {
                    this._inflight.splice(0, idx).forEach(item => {
                        item.controller.abort()
                    })
                }
                return result
            })
            .finally(() => {
                const idx = this._inflight.indexOf(entry)
                if (idx !== -1) {
                    this._inflight.splice(idx, 1)
                }
            })
    }
}
